<template>
    <div v-if="$mq == 'mobile'" id="menu" class="mobile">
        <div v-if="store.splashPage">
            <router-link :to="{ name: 'projects'}">JMMP</router-link>
            <span>
            Art Direction, Visual Identities, Books, Websites, Typefaces
            </span>
        </div>
        <div v-else-if="page=='about'" id="studioMenu">
            <a id="close" @click="handleClose">Close</a>
        </div>
        <div v-else-if="page=='index' || page=='images'" id="studioMenu">
            <router-link id="aboutLink" :class="{inverted: store.inverted}" :to="{ name: 'studio'}">About</router-link>
            <a href="/#/detail" @click.prevent="gotoDetail" >Slideshow</a>
            <div id="randomSpacer" class="mobile">

            <div id="indexToggle" class="mobile">
                <!--
                <div v-if="page=='index'" ref="leftMarker" id="leftMarker">
                </div>
                <div v-else id="rightMarker" ref="rightMarker">
                </div>
                -->
                <div id="marker" class="mobile" ref="marker"></div>
            <router-link id="listLink" class="mobile" :to="{ name: 'index'}">Text</router-link>
            <router-link id="imagesLink" class="mobile" :to="{ name: 'images'}">Images</router-link>
            </div>
            </div>
        </div>
        <div v-else id="detailMenu" :class="{inverted: store.inverted}">
            <span class="tabNum">{{ formatNumber(imageCounter) }}/{{ formatNumber(store.totalImages) }}</span>
            <div id="randomSpacer">
                <span @click="toggleRandom" id="toggleRandom">Random <span id="toggleButton" :class="{on: store.random}"><span id="toggleMarker"></span></span> </span>
            </div>
        </div>

    </div>
    <div v-else id="menu">

        <!--
        <router-link v-if="store.activeSlug && store.activeID" :to="{ name: 'detail-image', params: { slug: store.activeSlug, id: store.activeID }}">JMMP</router-link>
        <router-link v-else :to="{ name: 'detail'}">JMMP</router-link>
        -->
        <div v-if="store.splashPage">
            <router-link :to="{ name: 'projects'}">JMMP</router-link>
            <span>
            Art Direction, Visual Identities, Books, Websites, Typefaces
            </span>
        </div>
        <div v-else-if="page=='about'" id="studioMenu">
            <a id="close" @click="handleClose">Close</a>
        </div>
        <div v-else-if="page=='index' || page=='images'" id="studioMenu">
            <div id="aboutLinkSpacer">
                <router-link id="aboutLink" :class="{inverted: store.inverted}" :to="{ name: 'studio'}">About</router-link>
            </div>
            <a href="/#/detail" @click.prevent="gotoDetail" >Slideshow</a>
            <div id="randomSpacer">

            <div id="indexToggle">
                <!--
                <div v-if="page=='index'" ref="leftMarker" id="leftMarker">
                </div>
                <div v-else id="rightMarker" ref="rightMarker">
                </div>
                -->
                <div id="marker" ref="marker"></div>
                <!--
            <router-link id="listLink" :to="{ name: 'index'}">Text</router-link>
            <router-link id="imagesLink" :to="{ name: 'images'}">Images</router-link>
            <a href="/#/index" id="listLink" @click.prevent="gotoIndex" >Text</a>
            <a href="/#/images" id="imagesLink" @click.prevent="gotoImages" >Images</a>
                -->
            <router-link id="listLink" :to="{ name: 'index'}">Text</router-link>
            <router-link id="imagesLink":to="{ name: 'images'}">Images</router-link>
            </div>
            </div>
        </div>
        <div v-else id="detailMenu" :class="{inverted: store.inverted}">
            <div id="aboutLinkSpacer">
                <router-link id="aboutLink" :class="{inverted: store.inverted}" :to="{ name: 'studio'}">About</router-link>
            </div>
            <span class="tabNum">{{ formatNumber(imageCounter) }}/{{ formatNumber(store.totalImages) }}</span>
            <div id="randomSpacer">
                <span @click="toggleRandom" id="toggleRandom">Random <span id="toggleButton" :class="{on: store.random}"><span id="toggleMarker"></span></span> </span>
            </div>
        </div>
    </div>

</template>
<script>
import {store} from '@/centralStore';
export default {
    name: 'Menu',
    props: [
        'active',
        'imageCounter',
        'page'
    ],
    data(){
        return {
            store: store.state,
        }
    },

    watch: {
        '$route' (to, from) {
            let myself = this;
            if (from.name == 'images' && to.name == 'index'){
                //myself.$refs.marker.classList.add('right')
                //setTimeout(function(){
                    //myself.$refs.marker.classList.add('left')
                    //myself.$refs.marker.classList.remove('right')
                //}, 200)

            } else if (from.name == 'index' && to.name == 'images'){
                //myself.$refs.marker.classList.add('left')
                //setTimeout(function(){
                    //myself.$refs.marker.classList.add('right')
                    //myself.$refs.marker.classList.remove('left')
                //}, 200)

            } else if (to.name == 'images'){
                //console.log('images')
                //myself.$refs.marker.classList.add('right')
                //myself.$refs.marker.classList.remove('left')
            } else if (to.name == 'index'){
                //console.log('index')
                //myself.$refs.marker.classList.add('left')
                //myself.$refs.marker.classList.remove('right')
            }
        },
        //page: {
            //immediate: true,
            //handler (newPage, oldPage){
                //if (newPage == 'index'){
                    //this.$refs.marker.classList.remove('right')
                    //this.$refs.marker.classList.add('left')
                //} else if (newPage == 'images'){
                    //this.$refs.marker.classList.remove('left')
                    //this.$refs.marker.classList.add('right')
                //}

            //},
        //}
    },
    mounted(){
        let myself = this;
        if (myself.page == 'index'){
            if (myself.store.indexMounted == false && myself.store.imagesMounted == true){
                myself.$refs.marker.classList.add('right')
                setTimeout(function(){
                    myself.$refs.marker.classList.add('left')
                    myself.$refs.marker.classList.remove('right')
                    myself.store.indexMounted = true;
                }, 200)
            } else {
                myself.$refs.marker.classList.add('left')
                myself.store.indexMounted = true;

            }
        } else if (myself.page == 'images'){
            if (myself.store.imagesMounted == false && myself.store.indexMounted == true){
                myself.$refs.marker.classList.add('left')
                setTimeout(function(){
                    myself.$refs.marker.classList.add('right')
                    myself.$refs.marker.classList.remove('left')
                    myself.store.imagesMounted = true;
                }, 200)
            } else {
                myself.$refs.marker.classList.add('right')
                myself.store.imagesMounted = true;
            }
        }
    },

    activated(){
        let myself = this;

        if (myself.page == 'index'){
            if (myself.store.indexMounted == true && myself.store.imagesMounted == true && myself.store.prevRoute == 'images'){
                myself.$refs.marker.classList.add('right')
                setTimeout(function(){
                    myself.$refs.marker.classList.add('left')
                    myself.$refs.marker.classList.remove('right')
                }, 200)
            //} else {
                //myself.$refs.marker.classList.add('left')
                //myself.store.indexMounted = true;

            }
            myself.store.prevRoute = 'index'
        } else if (myself.page == 'images'){
            if (myself.store.imagesMounted == true && myself.store.indexMounted == true && myself.store.prevRoute == 'index'){
                myself.$refs.marker.classList.remove('right')
                myself.$refs.marker.classList.add('left')
                setTimeout(function(){
                    myself.$refs.marker.classList.add('right')
                    myself.$refs.marker.classList.remove('left')
                }, 200)
            //} else {
                //myself.$refs.marker.classList.add('right')
                //myself.store.imagesMounted = true;
            }
            myself.store.prevRoute = 'images'
        } else {
            myself.store.prevRoute = ''
        }


        //if (myself.page == 'index'){
            //myself.$refs.marker.classList.add('left')
        //} else if (myself.page == 'images'){
            //myself.$refs.marker.classList.add('right')
        //}
        //if (myself.store.toggle == true){
            //setTimeout(function(){
                //if (myself.page == 'index'){
                    //myself.$refs.leftMarker.classList.add('goLeft')
                //} else if (myself.page == 'images'){
                    //myself.$refs.rightMarker.classList.add('goRight')
                //}
            //}, 200)
        //} else {
            //if (myself.page == 'index'){
                //myself.$refs.leftMarker.classList.add('goLeft')
                //myself.store.toggle = true;
            //} else if (myself.page == 'images'){
                //myself.$refs.rightMarker.classList.add('goRight')
                //myself.store.toggle = true;
            //} else {
                //myself.store.toggle = false;
            //}

        //}
    },
    deactivated(){
        //let myself = this;
        //if (myself.page == 'index'){
            //myself.$refs.leftMarker.classList.remove('goLeft')
        //} else if (myself.page == 'images'){
            //myself.$refs.rightMarker.classList.remove('goRight')
        //}

    },
    methods:{
        formatNumber(number){
            return number.toString().padStart(3, '0');
        },
        gotoDetail(){
            this.store.detailTransition = 'slideUp';
            if (this.store.lastIndex == 'images'){
                this.store.imagesTransition = 'slideDown';
            } else {
                this.store.indexTransition = 'slideDown';
            }
            let myself = this;
            setTimeout(function(){
                if (myself.store.activeID){
                    myself.$router.push({name: 'detail-image', params:{slug: myself.store.activeSlug, id: myself.store.activeID}})
                } else if (myself.store.activeSlug){
                    myself.$router.push({name: 'detail-slug', params:{slug: myself.store.activeSlug}})
                } else {
                    myself.$router.push({name: 'detail'})
                }
            }, 100)
        },
        gotoImages(){
            this.store.indexTransition = 'fade'
            this.store.imagesTransition = 'fade'
            let myself = this;
            setTimeout(function(){
                myself.$router.push({name: 'images'})
            }, 500)
        },
        gotoIndex(){
            this.store.imagesTransition = 'fade'
            this.store.indexTransition = 'fade'
            let myself = this;
            setTimeout(function(){
                myself.$router.push({name: 'index'})
            }, 500)
        },

        handleClose(){
            this.$router.go(-1);
        },
        toggleRandom(){
            this.store.random = !this.store.random;
        },
    }
}


</script>
<style scoped>
a{
    color: #969696;
    text-decoration: none;
    cursor: pointer;
    position: relative;
    z-index: 10;
    transition: color .5s;
}
a:hover{
    color: #232323;
}
a.inverted:hover{
    color: white;
}
a.router-link-active{
    color: #232323;
}
#menu{
    /*margin: 11px 16px 0 16px;*/
    margin: 0.65rem 0.9375rem 0 1rem;
}
@media screen and (min-width: 800px) {
#menu{
    margin: 0.75rem 0.9375rem 0 1rem;
}
}
div{
}
#studioMenu{
    display: flex;
}
.mobile > #studioMenu{
    flex-wrap: wrap;
    justify-content: space-between;
}
#studioMenu > span{
    flex: 1;
}
#close{
    margin-right: 0;
}
#detailMenu{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
#detailMenu.inverted  a{
    /*color: white;*/
    /*transition: color .5s;*/
}
#detailMenu.inverted span{
    color: white;
    /*transition: color .5s;*/
}
#toggleRandom{
    cursor: pointer;
    color: #969696 !important;
    transition: color .5s;
}
#toggleRandom:hover{
    color: #232323;
}
#aboutLinkSpacer, #randomSpacer{
    flex-basis: 50%;
}
#randomSpacer{
    text-align: right;
}
#randomSpacer.mobile{
    margin-top: 0.75rem;
    margin-bottom: 0.7rem;
}
.mobile > #studioMenu > #randomSpacer{
    flex-basis: 100%;
}
#listLink{
    position: absolute;
    left: 2.8rem;
    top: 0.07rem;
}
#listLink.mobile{
    left: 5.2rem;
}
#imagesLink{
    position: absolute;
    right: 2rem;
    top: 0.07rem;
}
#imagesLink.mobile{
    right: 4.2rem;
}

#indexToggle{
    width: 14rem;
    height: calc(1.11rem + 4px);
    background-color: #e6e6e6;
    border-radius: 0.35rem;
    position: relative;
    display: inline-block;
    font-size: 0.875rem;
}
#indexToggle.mobile{
    width: 100%;
    font-size: 1rem;
    /*height: 1.5rem;*/
    height: calc(1.27rem + 6px);
}
#leftMarker{
    position: absolute;
    top: 2px;
    width: 70px;
    height: 36px;
    background-color: white;
    border-radius: 10px;
    transition: left .5s;
    left: calc(100% - 72px);
}
#rightMarker{
    position: absolute;
    top: 2px;
    width: 70px;
    height: 36px;
    background-color: white;
    border-radius: 10px;
    transition: left .5s;
    left: 2px;
}
#rightMarker.goRight{
    left: calc(100% - 72px);
}
#leftMarker.goLeft{
    left: 2px;
}
#marker{
    position: absolute;
    top: 2px;
    width: 7rem;
    height: 1.11rem;
    background-color: white;
    border-radius: 0.3rem;
    transition: left .15s;
    left: 2px;
    box-shadow: 0 0 .25rem 0 #d2d2d2;
}

#marker.mobile{
    width: 50%;
    left: 0.1rem;
    height: 1.27rem;
    top: 3px;
}
#marker.left{
    left: 0.105rem;
}
#marker.right{
    left: calc(100% - 7.1rem);
}
#marker.right.mobile{
    left: calc(100% - 12.5rem);
}

#toggleButton{
    position: relative;
    background-color: #e6e6e6;
    width: 1.75rem;
    height: 1rem;
    display: inline-block;
    border-radius: 0.75rem;
    transition: background-color .5s;
    margin-bottom: -3px;
    margin-left: .45rem;
}
@media screen and (min-width: 800px) {
#toggleButton{
    margin-left: .25rem;
}
}
#toggleMarker{
    position: absolute;
    background-color: white;
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 0.5rem;
    left: 0.105rem;
    top: 0.105rem;
    box-shadow: 0 0 .25rem 0 #d2d2d2;
    transition: left .5s;
}

#toggleButton.on{
    background-color: #6edc5f;
}
#toggleButton.on #toggleMarker{
    left: 0.85rem;
}


</style>
